import { useLazyQuery, useMutation } from "@apollo/client";
import { Box, Button, Pagination, Paper, Stack } from "@mui/material";
import { useAppDispatch } from "hooks/redux";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "shared/molecules/no-data";

import entitesClient from "utils/graphql/entitiesClient";

import {
  GET_COURSE_CLASS_SUBJECT_CHAPTER_MAPPINGS,
} from "utils/graphql/services/global-content-hierarchy/queries";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { table } from "./helper";
import { CscMappingFilter } from "./filter";
import { isEmpty } from "utils/helpers";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export default function CourseClassSubChapMap() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const classes = useStyles();
  const [searchPayload, setSearchPayload] = useState({});

  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);
  const [cscMappingTableData, setCscMappingTableData] = useState([]);

  const [getCourseClassSubChapList, { loading, error, data }] = useLazyQuery(
    GET_COURSE_CLASS_SUBJECT_CHAPTER_MAPPINGS,
    {
      client: entitesClient,
      fetchPolicy: "no-cache",
    }
  );
  

  const convertHandleTabledata = (fetchData) => {
    const tableData = fetchData.map((item) => {
      let obj = { ...item };
      obj["course"] = item?.course?.course_name;
      obj["subject"] = item?.subject?.global_name;
      obj["chapter"] = item?.chapter?.global_name;
      return obj;
    });
    setCscMappingTableData(tableData);
  };

  const handleChange = (event, value) => {
    setPage(value); // pass new page number to parent
  };


  useEffect(() => {
    getCourseClassSubChapList({
      variables: { filter: { ...searchPayload, page: page, limit } },
    });
  }, [searchPayload, page, limit]);

  useEffect(() => {
    const tableData =
      data?.getCourseClassSubjectChapterMappings?.records || [];
    if (tableData.length > 0) {
      convertHandleTabledata(tableData);
    } else if (isEmpty(tableData)) {
      setCscMappingTableData([]);
    }
  }, [data]);

  return (
    <>
      <ContentRight>
        <Link
          to="course_class_sub_chap_map/create"
          className={classes.label}
        >
          <Button variant="contained"> Create Mapping</Button>
        </Link>
      </ContentRight>

      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Course Class Subject Chapter Mapping{" "}
      </TypographyHeading>

      <CscMappingFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />

      <Paper elevation={2} sx={{ px: 2, pb: 4, pt: 2, mt: 2 }}>
        <div>
          {loading && <Loader />}
          {!loading && cscMappingTableData?.length > 0 ? (
           
            <CollapsibleTable
              data={cscMappingTableData}
              table={table}
              id="id"
              handleEdit={""}
              handleCopy={""}
            //   handleDelete={handleDeleteCourseClassSubChaMap}
              rowsPerPageCount={limit}
              paginationSegmentApi="false"
              hasPageApiCall={false}
              showPaginationFooter={false}
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data" />}</div>
          )}
        </div>
        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={
                Math.ceil(
                  data?.getCourseClassSubjectChapterMappings?.meta?.total /
                    limit
                ) || 1
              }
              page={page}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
